// Применение свежих котировок к кнопкам yes/no.
// Позиции и ордера юзера не трогаются: там показаны цены входа, а не рынок.

const USER_BLOCK_SELECTOR = '.market-bet--current, .market-bet--current-2, .market-bet--order';
const BET_ITEM_SELECTOR = '.bet-item[data-market_event_team_id][data-team]';

export const applyQuotes = (quotes, root = document) => {
    if (!quotes || typeof quotes.get !== 'function' || !root) return 0;

    let updated = 0;

    root.querySelectorAll(BET_ITEM_SELECTOR).forEach(item => {
        if (item.closest(USER_BLOCK_SELECTOR)) return;

        const teamId = item.getAttribute('data-market_event_team_id');
        const outcome = item.getAttribute('data-team');
        const teamQuotes = quotes.get(String(teamId));
        const quote = teamQuotes ? teamQuotes[outcome] : null;

        // Котировки нет — обе стороны стакана пусты. Оставляем последние
        // известные значения: один пустой ответ не должен обнулять кнопку,
        // а для беcордерной команды сервер рендерит пустой bid, который
        // клиенту воспроизводить нечем.
        if (!quote) return;

        item.setAttribute('data-best_price_asc', quote.ask);
        item.setAttribute('data-best_price_bid', quote.bid);
        item.setAttribute('data-percent', quote.percent);

        const rateElement = item.querySelector('.js_team_rate');
        if (rateElement) {
            rateElement.textContent = quote.ask;
            if (rateElement.hasAttribute('data-rate')) {
                rateElement.setAttribute('data-rate', quote.percent);
            }
        }

        updated += 1;
    });

    return updated;
};
